import { withState } from 'recompose';

export default withState('searchFilter', 'updateSearchFilter', false);
